import type { NDateLocale } from './enUS'
import { bn } from 'date-fns/locale'

const dateBnBD: NDateLocale = {
  name: 'bn-BD',
  locale: bn
}

export default dateBnBD
